import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { setHasChanged } from './sharedActions';

export const useSetFilterHasChanged = () => {
  const dispatch = useDispatch();

  const setFilterHasChanged = useCallback((hasChanged: boolean) => {
    dispatch(setHasChanged(hasChanged));
  // Only run this callback when hasChanged changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return setFilterHasChanged;
};
